import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { FormField, FormMultiDropdown } from "../../Common";
import { customerFilters, getFiltersValues, getGroupedFiltersValues } from "./FilterHelpers";
import Button from "../../Common/Button";

class FiltersForm extends PureComponent {
  static propTypes = {
    change: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    customersFilters: PropTypes.object,
    customersSelections: PropTypes.array,
    dirty: PropTypes.bool,
    initialValues: PropTypes.object
  };

  static defaultProps = {
    customersFilters: {},
    customersSelections: [],
    dirty: false,
    initialValues: {}
  };

  state = {
    selectedFilters: this.props.initialValues,
    isFormSubmitted: false
  };

  componentDidMount() {
    window.addEventListener("keydown", this.handlePanelEnter);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.dirty && this.props.dirty) {
      this.handleResetFormState();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handlePanelEnter);
  }

  get submitButtonIcon() {
    return this.state.isFormSubmitted ? "check-solid" : null;
  }

  get submitButtonLabel() {
    return this.state.isFormSubmitted ? i18n.t("button.saved") : i18n.t("filters.saveAsDefault");
  }

  handlePanelEnter = event => event.keyCode === 13 && this.handleSearch();

  handleResetFormState = () => this.setState({ isFormSubmitted: false });

  handleSelectFilter = (_field, values, _oldValue, fieldName) => {
    this.setState({ selectedFilters: { ...this.state.selectedFilters, [fieldName]: values } });
  };

  handleClearAllFilters = () => {
    Object.keys(customerFilters).forEach(field => this.props.change(field, ""));
    this.setState({ selectedFilters: {} });
  };

  handleResetFiltersToDefault = () => {
    Object.keys(customerFilters).forEach(fieldName => {
      this.props.change(fieldName, this.props.customersFilters[fieldName] || "");
    });

    this.setState({ selectedFilters: this.props.customersFilters });
  };

  handleOnSubmit = selectedFilters => {
    this.props.onSubmit(selectedFilters);
    this.setState({ isFormSubmitted: true });
  };

  handleSearch = () => this.props.onSearch(this.state.selectedFilters);

  render() {
    return (
      <div className="side-panel --customer">
        <div className="side-panel__header --filter">
          <p className="side-panel__header-title">{i18n.t("customer.filters")}</p>
        </div>
        <div className="side-panel__actions">
          <a role="presentation" className="side-panel__action --green" onClick={this.handleResetFiltersToDefault}>
            {i18n.t("filters.resetToDefault")}
          </a>
          <a role="presentation" className="side-panel__action --red" onClick={this.handleClearAllFilters}>
            {i18n.t("filters.clearAll")}
          </a>
        </div>

        <form name="customerFilters" className="side-panel__form">
          <Field
            component={FormField}
            placeholder={i18n.t("customer.enterAName")}
            className="side-panel__fieldset"
            name="partialCustomerName"
            label={i18n.t("customer.partialCustomerName")}
            onChange={this.handleSelectFilter}
          />
          <Field
            className="side-panel__fieldset"
            component={FormMultiDropdown}
            data={getFiltersValues(this.props.customersSelections, "assignedTo")}
            label={i18n.t("customer.assignedTo")}
            name="assignedTo"
            optionGroupsValues={getGroupedFiltersValues(this.props.customersSelections, "assignedTo", "representativeTypeValue")}
            placeholder={i18n.t("customer.all")}
            onChange={this.handleSelectFilter}
          />
          <Field
            component={FormMultiDropdown}
            className="side-panel__fieldset"
            data={getFiltersValues(this.props.customersSelections, "product")}
            placeholder={i18n.t("customer.all")}
            name="product"
            optionGroupsValues={getGroupedFiltersValues(this.props.customersSelections, "product", "bookOfBusinessValue")}
            label={i18n.t("products.product")}
            onChange={this.handleSelectFilter}
          />
          <Field
            component={FormMultiDropdown}
            className="side-panel__fieldset"
            data={getFiltersValues(this.props.customersSelections, "mill")}
            placeholder={i18n.t("customer.all")}
            name="mill"
            label={i18n.t("billsOfLading.mill")}
            onChange={this.handleSelectFilter}
          />
          <Field
            component={FormMultiDropdown}
            className="side-panel__fieldset"
            data={getFiltersValues(this.props.customersSelections, "customerType")}
            placeholder={i18n.t("customer.all")}
            name="customerType"
            label={i18n.t("customer.customerType")}
            onChange={this.handleSelectFilter}
          />

          <div className="side-panel__form-buttons">
            <Button
              className="side-panel__button --inverted --margin"
              label={i18n.t("customer.search")}
              onClick={this.props.handleSubmit(this.handleSearch)}
            />
            <Button
              icon={this.submitButtonIcon}
              className={classNames("side-panel__button", this.state.isFormSubmitted && "--filter-button")}
              labelClass="button__filter-label"
              iconClassName="button__filter-icon"
              label={this.submitButtonLabel}
              onClick={this.props.handleSubmit(this.handleOnSubmit)}
            />
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({ form: "customerFilters", enableReinitialize: true })(FiltersForm);



// WEBPACK FOOTER //
// ./src/components/Customer/Filters/FiltersForm.js